module.exports = __webpack_public_path__ + "img/berthelot.b3b43a2c.jpg";